// extracted by mini-css-extract-plugin
export var arrow = "_40-6";
export var changeItem = "_40-3";
export var changesHeader = "_40-1";
export var changesList = "_40-2";
export var container = "_40-0";
export var pathLabel = "_40-4";
export var value = "_40-7";
export var valuesContainer = "_40-5";